import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
/**
 * Report class
 */

export class Report extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getCompanies = () => {
      return this.model.companies;
    };

    this.getFormats = () => {
      return this.model.formats;
    };

    this.getTypes = () => {
      return this.model.items;
    };
  }

  /**
   * Create report
   *
   * @param {object} object
   *
   * @return {Report}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Get report companies
   *
   * @return {object}
   */


}